// Url paths:
export const personalLinkedIn = "https://www.linkedin.com/in/christoph-alberter/"
export const personalGitHub = "https://github.com/christophalberter"
